jQuery.noConflict();
jQuery(document).ready(function($) {

  let select_ID = 0;
  $('select.soff_tag_select').each(function(){
    //Create fake select and options containers
      $(this).after('<div id ="soff_tag_select_placeholder_' + select_ID + '" class="soff_tag_select_placeholder" data-toggle="dropdown" data-target="soff_tag_select_dropdown_' + select_ID + '"><span class="soff_tag_select_placeholder_text">' + $(this).find('option:selected').data('text') + '</span></div><div id ="soff_tag_select_dropdown_' + select_ID + '" class="soff_tag_select_dropdown soff_dropdown" data-select-id="' + $(this).attr('id') + '" data-select-placeholder-id="soff_tag_select_placeholder_' + select_ID + '" style="top:' + $(this).offset.top + '"></div>');

    //Populate options
    $(this).find('option').each(function(){
      let classes = "soff_tag_select_option_placeholder"
      if ($(this).is(':selected')){
        classes += " selected";
      }
        $('#soff_tag_select_dropdown_' + select_ID).append('<div class="' + classes + '" data-value="' + $(this).val()+ '"><div class="soff_tag_select_option_placeholder_text">' + $(this).data('text') + '</div></div>');
    })
    select_ID++;
  });

  //Select option from dropdown
  $('.soff_tag_select_option_placeholder').click(function(){
    let selectId = '#' + $(this).closest('.soff_tag_select_dropdown').data('select-id');
    let selectPlaceholderId = '#' + $(this).closest('.soff_tag_select_dropdown').data('select-placeholder-id');
    let newValue = $(this).data('value');
    let newText = $(this).find('.soff_tag_select_option_placeholder_text').html();
    $(selectPlaceholderId).find('.soff_tag_select_placeholder_text').html(newText);
    $(selectId).val(newValue).change();
  });

  $('.soff_tag_select_option_placeholder').mouseenter(function(){
    $(this).closest('.soff_tag_select_dropdown').find('.soff_tag_select_option_placeholder.selected').removeClass('selected');
    $(this).addClass('selected');
  });
});
